@if (isAuthenticated$ | async) {
  <ion-menu contentId="main-content">
    <ion-header>
      <ion-toolbar class="menu-header">
        <div class="menu-version">V {{ spaVersion }}@if (apiVersion$ | async; as apiVersion) { · API V{{ apiVersion }} }</div>
        <div class="menu-logo">
          <img src="assets/title.svg" alt="Logo" class="logo-image">
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      @if (activeTenant$ | async; as tenant) {
        <div class="tenant-card"
          [style.--tenant-accent]="tenant.accentColor || '#ffd166'">
          <div class="tenant-grid">
            @if (tenant.logoUrl) {
              <div class="tenant-logo">
                <img [src]="tenant.logoUrl" [alt]="tenant.name + ' logo'" (error)="handleTenantLogoError($event)">
              </div>
            } @else {
              <div class="tenant-initials">
                {{ tenant.name.slice(0, 2) || 'TN' }}
              </div>
            }
          </div>
          @if ((user$ | async)?.email; as email) {
            <div class="tenant-email">
              <span class="tenant-email-text">{{ email }}</span>
              @if (tenant.isAdmin) {
                <img class="tenant-role-badge" src="favicon.png" alt="" />
              }
            </div>
          }
          @if (tenant.description) {
            <div class="tenant-desc">{{ tenant.description }}</div>
          }
          @if (tenant.websiteUrl) {
            <a class="tenant-link" [href]="tenant.websiteUrl" target="_blank" rel="noopener">
              {{ 'menu.tenant.moreInfo' | tr }}
            </a>
          }
        </div>
        <div class="tenant-divider"></div>
      }
      <ion-list>
        <ion-item button [routerLink]="['/', activeTenantId$ | async, 'home']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
          <ion-icon color="primary" name="home-outline" slot="start"></ion-icon>
          <ion-label>{{ 'menu.nav.home' | tr }}</ion-label>
        </ion-item>
        <!-- "No companies" and "the request failed" both leave the list empty, but they are not the
             same message: one is a support case, the other resolves itself. Distinguished so a
             backend blip stops presenting as a permanent account problem. -->
        @if (tenantsUnavailable$ | async) {
          <div class="tenant-empty tenant-empty--error">
            {{ 'menu.tenant.loadFailed' | tr }}
            <button type="button" class="tenant-retry" (click)="retryTenants()">
              {{ 'menu.tenant.retry' | tr }}
            </button>
          </div>
        } @else if ((hasTenant$ | async) === false) {
          <div class="tenant-empty">
            {{ 'menu.tenant.noneAssigned' | tr }}
          </div>
        }
        @if (hasTenant$ | async) {
          <!-- ── Media group ──────────────────────────────────────────────── -->
          <div class="nav-group">
            <button class="nav-group-header" (click)="toggleGroup('media')">
              <span class="nav-group-label">{{ 'menu.group.media' | tr }}</span>
              <ion-icon name="chevron-down-outline" class="nav-group-chevron"
              [class.collapsed]="isGroupCollapsed('media')"></ion-icon>
            </button>
            <div class="nav-group-items" [class.collapsed]="isGroupCollapsed('media')">
              <div class="nav-group-items-inner">
                <ion-item button [routerLink]="['/', activeTenantId$ | async, 'screens']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
                  <ion-icon name="tv-outline" slot="start"></ion-icon>
                  <ion-label>{{ 'menu.nav.screens' | tr }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/', activeTenantId$ | async, 'playlists']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
                  <ion-icon name="list-outline" slot="start"></ion-icon>
                  <ion-label>{{ 'menu.nav.playlists' | tr }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/', activeTenantId$ | async, 'slides']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
                  <ion-icon name="document-outline" slot="start"></ion-icon>
                  <ion-label>{{ 'menu.nav.slides' | tr }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/', activeTenantId$ | async, 'banners']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
                  <ion-icon name="megaphone-outline" slot="start"></ion-icon>
                  <ion-label>{{ 'menu.nav.banners' | tr }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/', activeTenantId$ | async, 'analytics']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
                  <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
                  <ion-label>{{ 'menu.nav.analytics' | tr }}</ion-label>
                </ion-item>
              </div>
            </div>
          </div>
          <!-- ── Settings group ──────────────────────────────────────────── -->
          <div class="nav-group">
            <button class="nav-group-header" (click)="toggleGroup('settings')">
              <span class="nav-group-label">{{ 'menu.group.settings' | tr }}</span>
              <ion-icon name="chevron-down-outline" class="nav-group-chevron"
              [class.collapsed]="isGroupCollapsed('settings')"></ion-icon>
            </button>
            <div class="nav-group-items" [class.collapsed]="isGroupCollapsed('settings')">
              <div class="nav-group-items-inner">
                <ion-item button [routerLink]="['/', activeTenantId$ | async, 'seasons']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
                  <ion-icon name="calendar-outline" slot="start"></ion-icon>
                  <ion-label>{{ 'menu.nav.seasons' | tr }}</ion-label>
                </ion-item>
                @if (canIntegrations$ | async) {
                  <ion-item button [routerLink]="['/', activeTenantId$ | async, 'admin', 'integrations']" routerDirection="root"
                    routerLinkActive="active" (click)="closeMenu()">
                    <ion-icon name="cloud-outline" slot="start"></ion-icon>
                    <ion-label>{{ 'menu.nav.integrations' | tr }}</ion-label>
                  </ion-item>
                }
                @if (canAlerts$ | async) {
                  <ion-item button [routerLink]="['/', activeTenantId$ | async, 'alerts']" routerDirection="root"
                    routerLinkActive="active" (click)="closeMenu()">
                    <ion-icon name="notifications-outline" slot="start"></ion-icon>
                    <ion-label>{{ 'menu.nav.alerts' | tr }}</ion-label>
                  </ion-item>
                }
                @if (canSettings$ | async) {
                  <ion-item button [routerLink]="['/', activeTenantId$ | async, 'admin', 'settings']" routerDirection="root"
                    routerLinkActive="active" (click)="closeMenu()">
                    <ion-icon name="settings-outline" slot="start"></ion-icon>
                    <ion-label>{{ 'adminSettings.title' | tr }}</ion-label>
                  </ion-item>
                }
                @if (canUsers$ | async) {
                  <ion-item button [routerLink]="['/', activeTenantId$ | async, 'admin', 'users']" routerDirection="root"
                    routerLinkActive="active" (click)="closeMenu()">
                    <ion-icon name="people-outline" slot="start"></ion-icon>
                    <ion-label>{{ 'menu.nav.users' | tr }}</ion-label>
                  </ion-item>
                }
                @if (canUsers$ | async) {
                  <ion-item button [routerLink]="['/', activeTenantId$ | async, 'admin', 'groups']" routerDirection="root"
                    routerLinkActive="active" (click)="closeMenu()">
                    <ion-icon name="people-circle-outline" slot="start"></ion-icon>
                    <ion-label>{{ 'menu.nav.groups' | tr }}</ion-label>
                  </ion-item>
                }
                @if (canAuditLog$ | async) {
                  <ion-item button [routerLink]="['/', activeTenantId$ | async, 'admin', 'audit-log']" routerDirection="root"
                    routerLinkActive="active" (click)="closeMenu()">
                    <ion-icon name="journal-outline" slot="start"></ion-icon>
                    <ion-label>{{ 'menu.nav.auditLog' | tr }}</ion-label>
                  </ion-item>
                }
              </div>
            </div>
          </div>
          <!-- ── Support inbox – admins only; regular users use the floating widget ─ -->
          @if (canSupport$ | async) {
            <ion-item button [routerLink]="['/', activeTenantId$ | async, 'support']" routerDirection="root" routerLinkActive="active" (click)="closeMenu()">
              <ion-icon name="chatbubbles-outline" slot="start"></ion-icon>
              <ion-label>{{ 'menu.nav.support' | tr }}</ion-label>
            </ion-item>
          }
        }
      </ion-list>
    </ion-content>

    <!-- Outside ion-content so the three links stay pinned and visible even when the nav
         list is long enough to scroll. -->
    <ion-footer class="menu-footer ion-no-border">
      <!-- Legal texts are published in the Gastro Management portal, not in this app
           (core/constants/legal-links.ts). Opened in a new tab so an unsaved edit here
           is not lost by navigating away. -->
      <div class="legal-links-container">
        <ion-item button [href]="legal.url('impressum')" target="_blank" rel="noopener noreferrer"
          (click)="closeMenu()" lines="none" class="legal-link-item">
          <ion-label>{{ 'menu.legal.impressum' | tr }}</ion-label>
          <ion-icon name="open-outline" slot="end" aria-hidden="true"></ion-icon>
        </ion-item>
        <ion-item button [href]="legal.url('datenschutz')" target="_blank" rel="noopener noreferrer"
          (click)="closeMenu()" lines="none" class="legal-link-item">
          <ion-label>{{ 'menu.legal.datenschutz' | tr }}</ion-label>
          <ion-icon name="open-outline" slot="end" aria-hidden="true"></ion-icon>
        </ion-item>
        <ion-item button [href]="legal.url('agb')" target="_blank" rel="noopener noreferrer"
          (click)="closeMenu()" lines="none" class="legal-link-item">
          <ion-label>{{ 'menu.legal.agb' | tr }}</ion-label>
          <ion-icon name="open-outline" slot="end" aria-hidden="true"></ion-icon>
        </ion-item>
      </div>
    </ion-footer>
  </ion-menu>
}
